import { useEffect } from "react";
import "./About.css"
import Header from './Header';
import Footer from './Footer';
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const About = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);   // scroll to top
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <>
    <Header />
{/* <!-- Hero Section --> */}
<section className="about-hero">
    <div className="hero-background"></div>
    <div className="floating-element"></div>
    <div className="floating-element"></div>
    <div className="floating-element"></div>
    <div className="floating-element"></div>
    
    <div className="content-container">
        <div className="hero-content">
            <h1 className="hero-title">About Ask Jeeves IP</h1>
            <p className="hero-subtitle">Revolutionizing patent protection with O'Hanlon-powered AI efficiency and elite legal strategy</p>
            <div className="hero-tagline">Proprietary AI Gets You to 80%, O'Hanlon Attorneys Take It to 100%</div>
        </div>
    </div>
</section>

{/* <!-- Collaboration Section --> */}
<section className="collaboration-section">
    <div className="content-container">
        <div className="collaboration-content">
            <div className="collaboration-image" data-aos="fade-right">
                <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="AI and Legal Collaboration"/>
            </div>
            <div className="collaboration-text" data-aos="fade-left">
                <h2>Collaboration, Not Conflict:<br/>The O'Hanlon Patented Synergy</h2>
                <p>There is a myth that AI and attorneys are at odds. In the O'Hanlon framework, we have evolved past that thinking. The smartest legal teams now use our proprietary AI as their primary engine to move faster, increase precision, and secure market dominance without missing a single beat.</p>
                
                <div className="collaboration-highlights">
                    <div className="collaboration-highlight">
                        <div className="collaboration-highlight-icon">
                            <i className="fas fa-rocket"></i>
                        </div>
                        <div className="collaboration-highlight-content">
                            <h4>Supercharging the Attorney</h4>
                            <p>With Ask Jeeves IP, the attorney isn't fighting the system—they are supercharging it. Our platform uses O'Hanlon-patented algorithms to organize and accelerate the complex discovery process.</p>
                        </div>
                    </div>
                    
                    <div className="collaboration-highlight">
                        <div className="collaboration-highlight-icon">
                            <i className="fas fa-shield-alt"></i>
                        </div>
                        <div className="collaboration-highlight-content">
                            <h4>The Patent Protection Shield</h4>
                            <p>While our AI handles the heavy lifting of data orchestration, the attorney shapes and secures the final product. The result is a patent backed by O'Hanlon's proprietary methodology.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

{/* <!-- Mission Section --> */}
<section className="mission-section">
    <div className="content-container">
        <div className="mission-header" data-aos="fade-up">
            <h2>Our Mission: <span>Empowered by O'Hanlon Patents</span></h2>
            <p>Our mission is to democratize access to elite-level patent protection by combining cutting-edge AI with the established legal excellence of the O'Hanlon Patent framework.</p>
        </div>
        
        <div className="mission-content">
            <div className="mission-text" data-aos="fade-right">
                <p>We are committed to making high-quality, legally defensible patents accessible, affordable, and fast for startups and global innovators alike.</p>
                
                <div className="mission-points">
                    <div className="mission-point">
                        <i className="fas fa-key"></i>
                        <div className="mission-point-content">
                            <h4>Proprietary Innovation Access</h4>
                            <p>We leverage O'Hanlon-patented methodologies to break down the traditional barriers to intellectual property.</p>
                        </div>
                    </div>
                    
                    <div className="mission-point">
                        <i className="fas fa-bolt"></i>
                        <div className="mission-point-content">
                            <h4>Accelerated Legal Strategy</h4>
                            <p>By combining expert legal insights with O'Hanlon's proprietary AI algorithms, we transform the patent process.</p>
                        </div>
                    </div>
                    
                    <div className="mission-point">
                        <i className="fas fa-trophy"></i>
                        <div className="mission-point-content">
                            <h4>Affordable Market Dominance</h4>
                            <p>Through our patented efficiency models, we deliver superior IP strategy at a fraction of traditional costs.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mission-image" data-aos="fade-left">
                <img src="https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Mission Illustration"/>
            </div>
        </div>
    </div>
</section>

{/* <!-- AI Drafting Section --> */}
<section className="ai-drafting-section">
    <div className="content-container">
        <div className="ai-drafting-header" data-aos="fade-up">
            <h2>AI-Powered Drafting: Secured by O'Hanlon Patents</h2>
            <p>Transform the complexity of invention documentation into a streamlined, high-performance process.</p>
        </div>
        
        <div className="ai-drafting-content">
            <div className="ai-drafting-text" data-aos="fade-right">
                <p>Our platform utilizes proprietary methodologies secured by O'Hanlon Patents to help you draft precision invention summaries, organize technical flows, and architect foundational claim language.</p>
                
                <div className="ai-features">
                    <div className="ai-feature">
                        <i className="fas fa-cogs"></i>
                        <div className="ai-feature-content">
                            <h4>Patented Technical Orchestration</h4>
                            <p>Our AI identifies the optimal technical flow for your invention, ensuring every foundational element is strategically positioned.</p>
                        </div>
                    </div>
                    
                    <div className="ai-feature">
                        <i className="fas fa-language"></i>
                        <div className="ai-feature-content">
                            <h4>Proprietary Claim Language Synthesis</h4>
                            <p>Our engine suggests early claim language based on patented O'Hanlon frameworks for a robust legal starting point.</p>
                        </div>
                    </div>
                    
                    <div className="ai-feature">
                        <i className="fas fa-clock"></i>
                        <div className="ai-feature-content">
                            <h4>Accelerated Foundation Building</h4>
                            <p>Save critical time without compromising quality by leveraging patented efficiency models.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ai-drafting-image" data-aos="fade-left">
                <img src="https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="AI Drafting"/>
            </div>
        </div>
    </div>
</section>

{/* <!-- Expert Legal Section --> */}
<section className="expert-legal-section">
    <div className="content-container">
        <div className="expert-legal-content">
            <div className="expert-legal-image" data-aos="fade-right">
                <img src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Legal Expertise"/>
            </div>
            <div className="expert-legal-text" data-aos="fade-left">
                <h2>Expert Legal Refinement:<br/><span>The O'Hanlon Standard</span></h2>
                <p>True intellectual property protection requires more than just a filing; it requires a strategic offensive. Our real-world patent attorneys use the proprietary O'Hanlon framework to advance your innovations.</p>
                
                <div className="legal-points">
                    <div className="legal-point">
                        <i className="fas fa-balance-scale"></i>
                        <div className="legal-point-content">
                            <h4>Precision Claim Tightening</h4>
                            <p>Using O'Hanlon-patented methodologies, we refine your claim language to maximize protection while minimizing litigation risk.</p>
                        </div>
                    </div>
                    
                    <div className="legal-point">
                        <i className="fas fa-chess-queen"></i>
                        <div className="legal-point-content">
                            <h4>Proactive Objection Anticipation</h4>
                            <p>Our legal team uses proprietary AI-driven insights to anticipate examiner objections before they arise.</p>
                        </div>
                    </div>
                    
                    <div className="legal-point">
                        <i className="fas fa-chart-line"></i>
                        <div className="legal-point-content">
                            <h4>Strategic Business Alignment</h4>
                            <p>Every refinement aligns your claims with long-term commercial goals and market exit strategies.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

{/* <!-- Speed Section --> */}
<section className="speed-section">
    <div className="content-container">
        <div className="speed-header" data-aos="fade-up">
            <h2>Speed and Safety:<br/><span>The O'Hanlon Patented Standard</span></h2>
        </div>
        
        <div className="speed-content">
            <div className="speed-text" data-aos="fade-right">
                <p>Traditional firms often claim that strong patents require long delays. At Ask Jeeves IP, we've shattered that myth. By using a proprietary framework protected by O'Hanlon Patents, we eliminate administrative bottlenecks without compromising legal durability.</p>
                
                <div className="speed-points">
                    <div className="speed-point">
                        <i className="fas fa-robot"></i>
                        <h4>Eliminating the Grunt Work</h4>
                        <p>Our O'Hanlon-patented AI automates low-value tasks, transforming weeks of work into seconds of high-precision orchestration.</p>
                    </div>
                    
                    <div className="speed-point">
                        <i className="fas fa-flag-checkered"></i>
                        <h4>A "Nearly Finished" Foundation</h4>
                        <p>Our engine provides attorneys with a comprehensive, O'Hanlon-structured draft from the start.</p>
                    </div>
                    
                    <div className="speed-point">
                        <i className="fas fa-lock"></i>
                        <h4>The Safety of Proprietary Guardrails</h4>
                        <p>Every automated step is governed by patented legal logic, ensuring a "Zero-Error" framework.</p>
                    </div>
                </div>
            </div>
            <div className="speed-image" data-aos="fade-left">
                <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Speed and Safety"/>
                <div className="speed-stats">
                    <div className="speed-stat">
                        <h4>70%</h4>
                        <p>Faster Process</p>
                    </div>
                    <div className="speed-stat">
                        <h4>100%</h4>
                        <p>O'Hanlon Protected</p>
                    </div>
                    <div className="speed-stat">
                        <h4>0</h4>
                        <p>Quality Compromises</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

{/* <!-- Team Section --> */}
<section className="team-section section-container">
    <div className="content-container">
        <h2 className="section-title" data-aos="fade-up">O'Hanlon Innovation Leadership</h2>
        <p className="section-subtitle" data-aos="fade-up" data-aos-delay="100">Experts combining O'Hanlon legal excellence with proprietary AI innovation</p>
        
        <div className="team-grid">
            <div className="team-member" data-aos="fade-up" data-aos-delay="200">
                <div className="member-image">
                    <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Alex Johnson"/>
                </div>
                <div className="member-info">
                    <h3>Alex Johnson</h3>
                    <p className="member-role">CEO & Founder</p>
                    <p className="member-bio">Former O'Hanlon patent attorney with 15+ years experience in proprietary IP frameworks and technology innovation.</p>
                    <div className="member-tag">O'Hanlon Certified</div>
                </div>
            </div>
            
            <div className="team-member" data-aos="fade-up" data-aos-delay="300">
                <div className="member-image">
                    <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Sarah Chen"/>
                </div>
                <div className="member-info">
                    <h3>Sarah Chen</h3>
                    <p className="member-role">Chief Technology Officer</p>
                    <p className="member-bio">AI specialist with PhD in Machine Learning, architect of proprietary O'Hanlon-patented algorithms.</p>
                    <div className="member-tag">Patent Architect</div>
                </div>
            </div>
            
            <div className="team-member" data-aos="fade-up" data-aos-delay="400">
                <div className="member-image">
                    <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Marcus Rodriguez"/>
                </div>
                <div className="member-info">
                    <h3>Marcus Rodriguez</h3>
                    <p className="member-role">Head of Legal Operations</p>
                    <p className="member-bio">O'Hanlon-certified patent attorney specializing in proprietary software and hardware patent frameworks.</p>
                    <div className="member-tag">O'Hanlon Certified</div>
                </div>
            </div>
        </div>
    </div>
</section>

{/* <!-- Final CTA Section --> */}
<section className="final-cta-section">
    <div className="content-container">
        <div className="final-cta-content" data-aos="fade-up">
            <h2 className="cta-title">Ready to Protect Your Innovation?<br/>The O'Hanlon Standard Awaits.</h2>
            <p className="cta-text">Join hundreds of startups and global innovators who trust Ask Jeeves IP for patent protection that is fast, affordable, and architected to last. By leveraging the O'Hanlon Patent framework, we don't just file your patent—we fortify your future.</p>
            
            <div className="cta-points">
                <div className="cta-point" data-aos="fade-up" data-aos-delay="100">
                    <i className="fas fa-shield-check"></i>
                    <h4>Secure Your Patented Advantage</h4>
                    <p>Start with the world's most advanced AI legal engine, powered by O'Hanlon's proprietary methodologies.</p>
                </div>
                
                <div className="cta-point" data-aos="fade-up" data-aos-delay="200">
                    <i className="fas fa-bolt"></i>
                    <h4>Fast. Formidable. Defensible.</h4>
                    <p>Experience a streamlined process that delivers a high-quality, O'Hanlon-backed patent at the speed of modern innovation.</p>
                </div>
                
                <div className="cta-point" data-aos="fade-up" data-aos-delay="300">
                    <i className="fas fa-crown"></i>
                    <h4>Elite Protection for Every Founder</h4>
                    <p>Gain access to the same patented legal guardrails used by industry leaders, tailored for your scale and budget.</p>
                </div>
            </div>
            
            <div className="ctabout-buttons">
                <Link to={"/services"} className="cta-btn-primary">Start Your O'Hanlon Patent Today</Link>
                <Link to={"/contact"} className="cta-btn-secondary">Get Expert Guidance</Link>
            </div>
            
            <div className="patent-tagline">
                <i className="fas fa-certificate"></i>
                <span>Every patent secured by the O'Hanlon Innovation Shield</span>
            </div>
        </div>
    </div>
</section>
<Footer />
        </>
    )
}

export default About